export const CVV_CARD_MASK = '###';
export const AMEX_CARD_MASK = '#### ###### #####';
export const MAESTRO_CARD_MASK = '#### #### #### ######';
export const OTHER_CARD_MASK = '#### #### #### ####';
